export class JiraIssueCollector {
  constructor(private readonly issueCollectorCode: string) {}

  getIssueCollectorCode() {
    return this.issueCollectorCode;
  }
}
